// accion-refuerzo-form-modal.component.ts
import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { PlanRefuerzoComportamientoService } from "../../../../../shared/services/plan-refuerzo-comportamiento.service";
import { EstadoPlanAccionService, EstadoPlanAccion } from "../../../../../shared/services/estado-plan-accion.service";

@Component({
  selector: "app-accion-refuerzo-form-modal",
  templateUrl: "./accion-refuerzo-form-modal.component.html",
  styleUrls: ["./accion-refuerzo-form-modal.component.scss"],
})
export class AccionRefuerzoFormModalComponent implements OnInit {
  @Input() accion: any;
  @Input() colaboradores: any[] = [];
  @Input() cargandoColaboradores = false;

  form!: FormGroup;
  guardando = false;

  estadosPlan: EstadoPlanAccion[] = [];
  cargandoEstadosPlan = false;

  compararPorCedula = (a: any, b: any): boolean => {
    const valorA = a && typeof a === "object" ? a.cedula : a;
    const valorB = b && typeof b === "object" ? b.cedula : b;
    if (valorA === valorB) return true;
    if (valorA === null || valorA === undefined || valorB === null || valorB === undefined) return false;
    return String(valorA).trim() === String(valorB).trim();
  };

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private planRefuerzoService: PlanRefuerzoComportamientoService,
    private estadoPlanAccionService: EstadoPlanAccionService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      accion: [this.accion?.accion || "", Validators.required],
      responsable: [this.accion?.responsable ?? null],
      fecha_compromiso: [this.accion?.fecha_compromiso || null, Validators.required],
      estado_plan: [this.accion?.estado_plan ?? null, Validators.required],
      observaciones: [this.accion?.observaciones ?? null],
    });

    this.cargarEstadosPlan();
  }

  private cargarEstadosPlan(): void {
    this.cargandoEstadosPlan = true;
    this.estadoPlanAccionService.getEstados().subscribe({
      next: (response: any) => {
        this.estadosPlan = Array.isArray(response) ? response : response?.data || [];
        this.cargandoEstadosPlan = false;
      },
      error: () => {
        this.estadosPlan = [];
        this.cargandoEstadosPlan = false;
      },
    });
  }

  guardar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      Swal.fire("Campos obligatorios", "Completa la acción y la fecha de compromiso.", "warning");
      return;
    }

    const payload = this.form.getRawValue();
    this.guardando = true;

    this.planRefuerzoService.update(this.accion.id, payload).subscribe({
      next: () => {
        this.guardando = false;
        Swal.fire("Éxito", "Acción de refuerzo actualizada correctamente.", "success");
        this.activeModal.close(true);
      },
      error: (error: any) => {
        this.guardando = false;
        const mensaje = error?.error?.error || "No se pudo actualizar la acción de refuerzo.";
        Swal.fire("Error", mensaje, "error");
      },
    });
  }

  cerrar(): void {
    this.activeModal.dismiss();
  }
}